import { theme } from "@huub-web/ui/theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const messageStyle = style({
  position: "absolute",
  bottom: theme.spacings.m,
  left: theme.spacings.m,
  width: `calc(100% - ${theme.spacings.m} * 2)`,
  backgroundColor: theme.colors.infoSurface,
  borderRadius: theme.borderRadiuses.xs,
  padding: theme.spacings.xs,
  color: theme.colors.onInfoSurface,
});

export const carouselContainerStyle = style({
  overflow: "hidden",
  position: "relative",
  width: "100%",
});

export const carouselStyle = style({
  position: "absolute",
  width: "100%",
  overflow: "hidden",
});
